namespace Classes.Models {
    export class Company {
        id: number;
        name: string;
        organisationId: number;

        constructor(data = null) {
            this.id = data?.id ?? 0;
            this.name = data?.name ?? "";
            this.organisationId = data?.organisationId ?? 0;
        }
    }
}